import { C } from '.';

export default (serverRequest, language) => {
  let host = null;
  if (typeof window !== 'undefined') {
    host = window.location.host;
  } else if (serverRequest) {
    host = serverRequest.headers.host;
  }
  return (host !== null && C.MINUBE.DOMAINS[language].indexOf(host) === -1);
};
